import { render, staticRenderFns } from "./MigrationPopup.vue?vue&type=template&id=531f7dd4&scoped=true&"
import script from "./MigrationPopup.vue?vue&type=script&lang=ts&"
export * from "./MigrationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./MigrationPopup.vue?vue&type=style&index=0&id=531f7dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f7dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
